export const setUsers = items => ({
    type: 'SET_USERS',
    items,
});
